/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateDrugRegisterCommand } from '../models/CreateDrugRegisterCommand';
import type { DrugRegisterDtoListResponse } from '../models/DrugRegisterDtoListResponse';
import type { DrugRegisterDtoResponse } from '../models/DrugRegisterDtoResponse';
import type { SetDrugRegisterMinimumQuantityCommand } from '../models/SetDrugRegisterMinimumQuantityCommand';
import type { UpdateDrugRegisterStrengthCommand } from '../models/UpdateDrugRegisterStrengthCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DrugRegistersService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param drugId
     * @returns DrugRegisterDtoListResponse Success
     * @throws ApiError
     */
    public getApiDrugRegistersDrugRegisters(
        drugId?: string,
    ): CancelablePromise<DrugRegisterDtoListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/DrugRegisters/DrugRegisters',
            query: {
                'DrugId': drugId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns DrugRegisterDtoResponse Success
     * @throws ApiError
     */
    public postApiDrugRegistersCreateDrugRegister(
        requestBody?: CreateDrugRegisterCommand,
    ): CancelablePromise<DrugRegisterDtoResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/DrugRegisters/CreateDrugRegister',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns DrugRegisterDtoResponse Success
     * @throws ApiError
     */
    public putApiDrugRegistersSetMinimumQuantity(
        requestBody?: SetDrugRegisterMinimumQuantityCommand,
    ): CancelablePromise<DrugRegisterDtoResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/DrugRegisters/SetMinimumQuantity',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns DrugRegisterDtoResponse Success
     * @throws ApiError
     */
    public putApiDrugRegistersUpdateStrength(
        requestBody?: UpdateDrugRegisterStrengthCommand,
    ): CancelablePromise<DrugRegisterDtoResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/DrugRegisters/UpdateStrength',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                409: `Conflict`,
                500: `Server Error`,
            },
        });
    }
}
